// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"0c2bb286","673":"8e42e9e1","767":"60079d66"}[chunkId] + ".chunk.js";
};